export const CUSTOMER_TYPE =
    {
        SENDER: 0,
        RECIPIENT: 1,
    }
